import React, { useState, useCallback, useMemo } from 'react';
import { withStyles } from '@material-ui/styles';
import Select from 'react-select';
import differenceBy from 'lodash.differenceby';
import flowRight from 'lodash.flowright';
import { injectIntl } from 'react-intl';
import clsx from 'clsx';

import styles, { customSelectStyles } from '../styles/roles';
import PrimaryButton from '../../../partials/customButtons/PrimaryButton';
import { reactSelectDefaultStyles } from '../../../consts/reactSelectDefaultStyles';
import withUserCheck from '../../../utils/withUserCheck';
import { connect } from 'react-redux';

export function Roles({
  intl,
  classes,
  arrayHelpers: {
    form: {
      values: { roles = [] }
    },
    remove,
    push
  },
  options,
  clientId
}) {
  const [selected, setSelected] = useState({});

  const onAddClick = useCallback(
    () => {
      push({ name: selected.label, id: selected.value.toString() });
      setSelected({});
    },
    // eslint-disable-next-line
    [selected]
  );

  const availableOptions = useMemo(
    () => [...mapOptions(options, roles)],
    // eslint-disable-next-line
    [options, roles]
  );

  return (
    <div className={classes.root}>
      <div className={classes.label}>
        {intl.formatMessage({
          id: 'MENU.ROLES'
        })}
      </div>
      <div className={classes.selectColumn}>
        <div className={classes.selectContainer}>
          <Select
            className={classes.fieldValue}
            styles={reactSelectDefaultStyles}
            customStyles={customSelectStyles}
            isSearchable
            maxMenuHeight={145}
            options={availableOptions}
            onChange={value => setSelected(value)}
            value={Object.keys(selected).length !== 0 ? selected : null}
          />
          <PrimaryButton
            onClick={onAddClick}
            disabled={Object.keys(selected).length === 0}
            minWidth={'unset'}
          >
            {intl.formatMessage({
              id: 'BUTTON.ADD'
            })}
          </PrimaryButton>
        </div>

        <div className={classes.rolesContainer}>
          {roles.map((role, i) => (
            <div className={classes.roleContainer} key={role.name}>
              {role.name}
              <i
                className={clsx('far fa-times-circle', classes.icon)}
                onClick={() => remove(i)}
              ></i>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
const mapStatesToProps = ({ editCustomJob }) => {
  return {
    options: editCustomJob.selectRolesOptions
  };
};

export default flowRight(
  injectIntl,
  withUserCheck,
  connect(mapStatesToProps),
  withStyles(styles)
)(Roles);

function mapOptions(options, roles) {
  const changedRoles = roles.map(role => {
    return { label: role.name, value: Number(role.id) };
  });

  return differenceBy(options, changedRoles, 'label');
}
